var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-tipo-documento',{ref:"modalTipoDocumento",attrs:{"exibir":_vm.exibir,"tipo-documento":_vm.tipoDocumento},on:{"confirmar":_vm.confirmar,"fechar-modal":_vm.fecharModal}})}
var staticRenderFns = []

export { render, staticRenderFns }